import React, { FC } from 'react'

interface AttributeValue {
    val_id: string;
    value: string;
  }
  
  interface Attribute {
    attr_id?: string;
    attr_name?: string;
    attr_value: AttributeValue[];
  }

const Attributes: FC<Attribute> = ({attr_value}) => {
  return (
    <React.Fragment>
        <h3 className={`tw-mt-3 tw-ms-1 tw-text-sm`}>Attributes</h3>
    
    <div className={`tw-flex tw-flex-wrap tw-justify-start`}>
            {attr_value?.map((attribute: any, index: number) => {
              let valuesArr = attribute.attr_value;
              let varr: any = [];
              valuesArr.forEach((valObj:any) =>
                varr.push(valObj.value)
              );
              return(
              <div key={index } style={{overflowWrap: "break-word"}} className={`tw-w-1/3 tw-p-1 tw-mt-3`}>
                <h2 className={`tw-text-sm`}>{attribute?.attr_name ?? "---"}</h2>
                {/* <h2 className={`tw-text-sm`}>{attribute?.attr_name?.toUpperCase() ?? "---"}</h2> */}
                <h4 className={`tw-text-sm tw-font-normal tw-mt-1 tw-text-[#5C5F62]`}>{varr?.toString()  ?? "---"}</h4>
              </div>
            )})}
          </div>
          </React.Fragment>
  )
}

export default Attributes